var publicPath = '/static/';
            var symbolUrl = 'img/sprite.03adb9c4.svg#icon-bookmark';
            var viewUrl = 'img/sprite.03adb9c4.svg#view-icon-bookmark';

            

            module.exports = {
                symbol: publicPath + symbolUrl,
                view: publicPath + viewUrl,
                viewBox: '0 0 14 19',
                title: '',
                toString: function () {
                    return JSON.stringify(this.view);
                }
            };